"use client";
import { VerticalFilter } from "@/components/VerticalFilter";
import { Analytics, TreeNode } from "@/types/General";
import { FC, useContext } from "react";
import { IndexCardsContext } from "./IndexContextBlock";
import { BuilderBlockProps } from "@/types";
import { CscInternalSearchContext } from "../InternalSearch/CscInternalSearchContextBlock";

type VerticalFilterProps = {
  filterVariant?: "index" | "search";
  variant: "standard" | "button-trigger";
  filterAnalytics: Analytics;
  name: string;
  clearAll: {
    text: string;
  } & Analytics;
  selectAll: {
    text: string;
  } & Analytics;
  deselectAll: {
    text: string;
  } & Analytics;
  applyFilter: {
    text: string;
  } & Analytics;
  configuration?: { parameterName: string }[];
} & BuilderBlockProps;

export const VerticalFilterBlock: FC<VerticalFilterProps> = ({
  filterVariant = "index",
  applyFilter,
  filterAnalytics,
  name,
  clearAll,
  selectAll,
  deselectAll,
  attributes,
  variant,
  configuration,
}) => {
  const indexContext = useContext(IndexCardsContext);
  const searchContext = useContext(CscInternalSearchContext);

  const context = filterVariant === "search" ? searchContext : indexContext;
  const { selectedFilters, onFilter, filters } = context;

  return (
    filters?.length > 0 && (
      <VerticalFilter
        defaultOpen={filterVariant === "search"}
        sortByName={filterVariant !== "search"}
        applyFilter={applyFilter}
        variant={variant}
        analytics={filterAnalytics}
        name={name}
        selectedFilters={selectedFilters}
        clearAll={clearAll}
        selectAll={selectAll}
        deselectAll={deselectAll}
        onFilter={onFilter}
        filters={
          configuration?.reduce(
            (
              acc,
              currentValue,
            ): {
              label: string;
              name: string;
              categories: TreeNode[];
            }[] => {
              const filter = filters.find(
                ({ name }) => name === currentValue.parameterName,
              );

              if (filter) {
                return [...acc, filter];
              }

              return acc;
            },
            [],
          ) ?? filters
        }
        {...attributes}
      />
    )
  );
};
